module.exports = __webpack_public_path__ + "static/media/DSCN0347.5a8bc9cd.jpg";